import { render } from "./QuantGoldBacktest.vue?vue&type=template&id=04267c02&scoped=true&ts=true"
import script from "./QuantGoldBacktest.vue?vue&type=script&lang=ts"
export * from "./QuantGoldBacktest.vue?vue&type=script&lang=ts"

import "./QuantGoldBacktest.vue?vue&type=style&index=0&id=04267c02&lang=less&scoped=true"
import "./QuantGoldBacktest.vue?vue&type=style&index=1&id=04267c02&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04267c02"]])

export default __exports__